import React from 'react';
import { Dropdown, Button, ButtonGroup } from 'react-bootstrap';
import './ButtonWithMenu.scss';

const ButtonWithMenu = (props) => {
  const {
    options,
    title,
    itemAction,
    onClick,
    itemClassName,
    parentClassName,
  } = props;
  const buttonList = options?.map((button) => {
    return (
      <Dropdown.Item
        className={`dropdown-button-item ${itemClassName}`}
        href="#"
        key={button.label}
        onClick={() => {
          itemAction(button);
        }}
      >
        {button.label}
      </Dropdown.Item>
    );
  });
  return (
    <Dropdown as={ButtonGroup} className={`dropdown-button ${parentClassName}`}>
      <Button
        id="btn-with-menu"
        variant="success"
        className="btn btn-sm btn-outline-primary btn-first"
        onClick={onClick}
      >
        {title}
      </Button>
      <Dropdown.Toggle
        split
        variant="success"
        id="dropdown-split-basic"
        className="btn btn-sm btn-outline-primary btn-second"
      />
      <Dropdown.Menu>{buttonList}</Dropdown.Menu>
    </Dropdown>
  );
};

export default ButtonWithMenu;
